import * as React from "react";
const SvgTransferHorizontal = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m17.469 3.354-.532.53-.533.534L17.7 5.715l1.297 1.295-8.404.002-8.406.004-.002.75-.002.752h16.824l-1.3 1.3-1.302 1.301.534.533.53.534 2.208-2.207a793.692 793.692 0 0 0 2.205-2.21c0-.002-.992-.997-2.205-2.21zM6.535 11.82l-2.207 2.207-2.209 2.21 2.21 2.206 2.206 2.21.533-.534.534-.533-1.297-1.295-1.295-1.297 8.404-.002 8.404-.002.002-.752.004-.752H5l1.3-1.3 1.302-1.301-.534-.532z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgTransferHorizontal;
